import { LeadStatus } from "../../../../models/Lead";

export default function LeadStatusCell({ status }: { status: LeadStatus }) {
    var classNames = "rounded-full px-3 py-1 text-xs font-semibold text-nowrap ";
    switch (status) {
        case LeadStatus["Awaiting Contact"]:
            classNames += "bg-yellow-100 text-yellow-800";
            break;

        case LeadStatus["Scheduled"]:
            classNames += "bg-blue-100 text-blue-800";
            break;

        case LeadStatus["Cancelled"]:
            classNames += "bg-red-100 text-red-800";
            break;

        case LeadStatus["Reschedule"]:
            classNames += "bg-orange-100 text-orange-800";
            break;

        case LeadStatus["Collected"]:
            classNames += "bg-green-100 text-green-800";
            break;

        case LeadStatus["Awaiting Payment"]:
            classNames += "bg-purple-100 text-purple-800";
            break;

        case LeadStatus["Awaiting COD"]:
            classNames += "bg-pink-100 text-pink-800";
            break;

        case LeadStatus["Customer to Call Back"]:
            classNames += "bg-indigo-100 text-indigo-800";
            break;

        case LeadStatus["Completed"]:
            classNames += "bg-green-100 text-green-800";
            break;

        case LeadStatus["All"]:
            classNames += "bg-gray-100 text-gray-800";
            break;

        default:
            classNames += "bg-gray-100 text-gray-800";
            break;
    }

    return <span title="Lead Status" className={classNames}>{LeadStatus[status]}</span>
}